<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="18" class="content-left">
              <el-form-item label="名称" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
               <el-form-item label="上传文件" prop="file_url">
                <!-- <el-input v-model="formData.file_url"></el-input> -->
                <upload-file
                  @remove_file="handleRemoveFile"
                  @return_url="handUploadFile"
                  :multiple="'false'"
                  :dir="'bill'"
                  :selectfiles="'importExcel'"
                  :postfiles="'submitImportExcel'"
                  :ossfile="'ossExcelFile'"
                  ref="uploadImg"
                  :max_width="1000"
                  :max_height="1000"
                />
               </el-form-item>
              <el-form-item label="备注" prop="desc">
                <el-input type="textarea" v-model="formData.desc"></el-input>
              </el-form-item>

            </el-col>
            <el-col class="content-right" :span="6">
              <!-- <el-form-item label="附件" prop="attachment">
                <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
              </el-form-item> -->
              <el-form-item label="来源" prop="source">
                <el-select size="medium" v-model="formData.source" filterable placeholder="请选择">
                  <el-option
                    v-for="item in sourceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态" prop="status" size="small">
                <el-radio-group v-model="formData.status">
                  <el-radio-button disabled label="0">待审核</el-radio-button>
                  <el-radio-button disabled label="1">审核已通过</el-radio-button>
                  <el-radio-button disabled label="2">审核不通过</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <div class="right-button">
                <el-form-item>
                  <el-button size="medium" type="primary"  :disabled="formDisabled" @click="saveConfirm">保存</el-button>
                  <el-button size="medium" @click="returnList">返回</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      isSave: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      sourceList: [
        {
          id: 'saas',
          name: '系统'
        },
        {
          id: 'openapi',
          name: '开放平台'
        }
      ],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{
        source: 'saas',
        file_url: '',
        status: 0
      },
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur' },
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename}) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url
      console.log("formData", this.formData)
    },
    // 返回列表
    returnList() {
      this.$router.push('/bill')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length-1)]
        this.formData.category_2_ids = v
      } else {
         this.formData.category_2_id = ''
         this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      console.log("formData -> ", this.formData);
      try {
        let id = await this.$api.saveBill(this.formData)
        if (id.length > 0) {
          this.isSave = true
          this.$notify.success('保存成功！')
          if (this.billId === 0 && id) {
            this.$router.push(this.$route.matched[1].path)
          }
        }
        this.$nextTick(() => {
          this.loadingStaus = false
        })
      } catch(err) {
        console.log('err is ->', err)
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    // 初始化公司基本信息
    async initCompanyForm() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.bill_id) {
        this.billId = this.$route.params.bill_id
      }
      if (this.billId) {
        let {info} = await this.$api.getBillInfo(this.billId)
        console.log("formData", info)
        this.formData = info
      }
    },
  },
  async mounted() {
    this.loadingStaus = true
    this.initCompanyForm()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 15px 0
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
</style>
